import { GuestAware } from '@/app/system/guest/GuestAware';
import { Guest } from '@/app/system/guest/Guest';
import { PatronPool } from '@/app/system/guest/PatronPool';

export interface SourceType<T> extends GuestAware<T>, Guest<T> {}

export class Source<T> implements GuestAware<T>, Guest<T> {
  private pool = new PatronPool(this);

  public constructor(private sourceDocument: T) {}

  introduction() {
    return 'guest' as const;
  }

  receive(value: T): this {
    this.sourceDocument = value;
    this.pool.receive(this.sourceDocument);
    return this;
  }

  receiving(guest: Guest<T>): this {
    this.pool.distributeReceivingOnce(this.sourceDocument, guest);
    return this;
  }
}
